// src/components/songEdit/components/InputWithIcon.tsx
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface InputWithIconProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon: LucideIcon;
  onIconClick: () => void;
  rightIcon?: LucideIcon;
  onRightIconClick?: () => void;
  required?: boolean;
  placeholder?: string;
}

export const InputWithIcon: React.FC<InputWithIconProps> = ({
  label,
  name,
  value,
  onChange,
  icon: Icon,
  onIconClick,
  rightIcon: RightIcon,
  onRightIconClick,
  required,
  placeholder
}) => (
  <div className="song-form__group">
    <label className="song-form__label">{label} {required && '*'}</label>
    <div className="input-group">
      <input
        type="text"
        className="song-form__input form-control"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
      />
      {RightIcon && (
        <button 
          className="btn btn-icon btn-secondary"
          onClick={onRightIconClick}
          type="button"
        >
          <RightIcon size={20} />
        </button>
      )}
      <button 
        className="btn btn-icon btn-secondary"
        onClick={onIconClick}
        type="button"
      >
        <Icon size={20} />
      </button>
    </div>
  </div>
);